import { storageDateFormat } from '@/core';
import moment from 'moment';

export default function() {
	return {
		deviations: [],
		deviationsLoading: false,
		searchFilter: {
			date: {
				from:moment().startOf('day')
					.subtract(7,'d')
					.format(storageDateFormat),
				to:''
			},
			deviationNumber: null,
			clerk: {},
			status: null,
			deviationType: null,
			deviationCause: null,
			actionType: null,
			terminal: {},
			goodsTypes: [],
			vendors: [],
			customers: [],
			customerFault: undefined,
		},
		loadedSearch: { id:-1, labelKey: 'resetSearch', },
	};
}
